import type { ShortUrlInfo } from './context/types';
import { useShortUrlsInfo } from './useShortUrlsInfo';

export function useShortUrlInfo(longUrl: string): ShortUrlInfo {
	return useShortUrlsInfo({ single: longUrl }).single;
}
